import { styled } from "configs/stitches.config";

export const MainContent = styled("div", {
  minHeight: "calc(100vh - 64px)",
  m: "0 auto",
  my: "64px",
  py: "38px",
  width: "1196px",
});

export const FooterWrapper = styled("footer", {
  backgroundColor: "$primary1",
  position: "relative",
  mt: "60px",

  "&::before": {
    content: "''",
    position: "absolute",
    top: "-58px",
    left: 0,
    width: "100%",
    height: "100%",
    background: "url('/images/footer-bg.png')",
  },
});
